<template>
  <v-container fluid>
    <template v-if="driverDetails">
      <v-row wrap>
        <v-col cols="6" class="py-1">
          <DisplayField label="Name" :value="driverName" />
        </v-col>
        <v-col cols="6" class="py-1">
          <DisplayField label="DOB" :value="driverDetails.dateOfBirth" type="piiDate" />
        </v-col>
        <v-col v-if="isPersonal" cols="6" class="py-1">
          <DisplayField label="Marital Status" :value="maritalStatus" />
        </v-col>
        <v-col v-if="isPersonal" cols="6" class="py-1">
          <DisplayField label="Relationship" :value="driverDetails.relationship" />
        </v-col>

        <v-col cols="6" class="py-1">
          <DisplayField label="Gender" :value="gender" />
        </v-col>
        <v-col v-if="isPersonal" cols="6" class="py-1">
          <DisplayField label="Occupation" :value="driverDetails.occupation" />
        </v-col>
        <v-col v-if="isPersonal" cols="6" class="py-1">
          <DisplayField label="Education" :value="educationLevel" />
        </v-col>
      </v-row>

      <v-divider />

      <v-row>
        <v-col cols="12" class="section-header pb-1">Boat Education</v-col>
        <v-col cols="6" class="py-1">
          <DisplayField label="USPS" :value="driverDetails.boat.uspsEducation" type="bool" />
        </v-col>
        <v-col cols="6" class="py-1">
          <DisplayField label="CGA" :value="driverDetails.boat.cgaEducation" type="bool" />
        </v-col>
        <v-col cols="6" class="py-1">
          <DisplayField label="Hands On" :value="driverDetails.boat.handsOnEducation" type="bool" />
        </v-col>
        <v-col :cols="6" class="py-1">
          <DisplayField label="Other" :value="otherEducation" />
        </v-col>
      </v-row>

      <v-divider />

      <v-row>

        <v-col cols="12" class="section-header pb-1">Operator Information</v-col>
        <v-col cols="6" class="py-1">
          <DisplayField label="Suspended/Revoked" :value="driverDetails.suspended" type="bool" />
        </v-col>
        <v-col cols="6" class="py-1">
          <DisplayField label="Years Experience" :value="driverDetails.boat.yearsExperience" />
        </v-col>
        <v-col cols="6" class="py-1">
          <DisplayField label="Prior Boats Owned" :value="driverDetails.boat.priorBoatsOwned" />
        </v-col>
        <v-col cols="6" class="py-1">
          <DisplayField label="License Number" :value="maskedDl" />
        </v-col>
          <v-col cols="6" class="py-1">
            <DisplayField label="Date Licensed" :value="driverDetails.licenseIssueDate" type="date" />
          </v-col>
        <v-col cols="6" class="py-1">
          <DisplayField label="Prior Boat Losses" :value="priorBoatLosses" />
        </v-col>
      </v-row>
    </template>
    <template v-else-if="!loading">
      <v-row>
        <v-col>
          Unable to get information. Please try again later.
        </v-col>
      </v-row>
    </template>

    <v-dialog v-model="loading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Loading driver details...
          <v-progress-linear indeterminate color="white" class="mb-0" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<style scoped>
.section-header {
    font-style: normal;
    font-weight: bold;
    font-size: 12px;
    line-height: 12px;
    letter-spacing: 0.25px;
    text-transform: uppercase;
    color: #767676;
  }
</style>

<script>
import enumService from '@/services/shared/enumService.js';
import { mapState, mapActions } from 'vuex';

import DisplayField from '@/components/Shared/DisplayField.vue';

export default {
  name: 'OperatorDetail',
  components: {
    DisplayField
  },
  props: {
    driverDetails: {
      type: Object,
      required: true
    },
    loading: Boolean
  },
  data: function () {
    return {
      viewingMore: false
    };
  },
  computed: {
    ...mapState(['selectedLineOfBusinessCode']),
    clientId: function () {
      return this.$route.params.clientId;
    },
    policyOrderNumber: function () {
      return this.$route.params.policyOrderNumber;
    },
    lobCode: function () {
      return this.selectedLineOfBusinessCode;
    },
    driverId: function () {
      return this.$route.params.driverId;
    },
    driverName () {
      return this.driverDetails.firstName + ' ' + this.driverDetails.lastName + ' ' + this.driverDetails.suffix;
    },
    isPersonal () {
      return this.driverDetails.type === 1;
    },
    isCommercial () {
      return this.driverDetails.type === 0;
    },
    viewMoreText: function () {
      return this.viewingMore ? 'View Less' : 'View More';
    },
    operatorStatus () {
      return enumService.operatorStatuses[this.driverDetails.operatorStatus];
    },
    maritalStatus () {
      return enumService.maritalStatuses[this.driverDetails.maritalStatus];
    },
    gender () {
      return enumService.genders[this.driverDetails.gender];
    },
    educationLevel () {
      return enumService.educationLevels[this.driverDetails.educationLevel];
    },
    otherEducation () {
      if ((this.driverDetails.boat || null) == null) return '';
      if (this.driverDetails.boat.otherEducation && this.driverDetails.boat.otherEducationDescription) {
        return this.driverDetails.boat.otherEducationDescription;
      }

      return this.driverDetails.boat.otherEducation ? 'Yes' : 'No';
    },
    priorBoatLosses () {
      if ((this.driverDetails.boat || null) == null) return '';
      if (this.driverDetails.boat.priorBoatLoss && this.driverDetails.boat.priorBoatLossExplanation) {
        return this.driverDetails.boat.priorBoatLossExplanation;
      }

      if (this.driverDetails.boat.priorBoatLoss === undefined) return '';

      return this.driverDetails.boat.priorBoatLoss ? 'Yes' : 'No';
    },
    maskedDl () {
      return '********' + this.driverDetails.licenseNumberLastTwo;
    }
  },
  methods: {
    ...mapActions(['setError'])
  }
};
</script>
